module.exports = __webpack_public_path__ + "media/images/home/bg-1-19aae6beac9323a09761fc468fc3a640.png";